import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import { pathTo } from '@/lib/search';
import s from './EntityLink.module.css';

/** Canonical entity pages (IA §3). Modules add types with `registerEntityHref`. */
const hrefs: Record<string, (id: string) => string> = {
  vehicle: (id) => `/vehicles/${id}`,
  driver: (id) => `/drivers/${id}`,
  device: (id) => `/devices/${id}`,
  group: (id) => `/fleet/groups?group=${id}`,
};

export function registerEntityHref(type: string, fn: (id: string) => string): void {
  hrefs[type] = fn;
}

export function entityHref(type: string, id: string): string | null {
  return hrefs[type]?.(id) ?? null;
}

/** A link to an entity's one page. Falls back to plain text for unknown types. */
export function EntityLink({
  type,
  id,
  children,
  className,
  mono,
}: {
  type: string;
  id: string | null | undefined;
  children: ReactNode;
  className?: string;
  mono?: boolean;
}) {
  const href = id ? entityHref(type, id) : null;
  if (!href) return <span className={cx(mono && s.mono, className)}>{children}</span>;
  return (
    <Link {...pathTo(href)} className={cx(s.entityLink, mono && s.mono, className)} onClick={(e) => e.stopPropagation()}>
      {children}
    </Link>
  );
}
